import '../../css/custom.css';
import '../../css/username.css';
import { NotificationBell, NotificationList } from '@zeeve-platform/in-app-notifications-frontend';
import { Header, HeaderDropdownItemProps, Organization } from '@zeeve-platform/header-component';
import TokenManager from '@zeeve-platform/login-utility';
import { IconUser } from '@zeeve-platform/icons/user/outline';
import { useEffect, useMemo, useState } from 'react';
import { IconPhoneVolume } from '@zeeve-platform/icons/phone/outline';
import { Offcanvas } from 'react-bootstrap';
import ZeeveLogo from '../../images/zeeve3/zeeve-logo-on-light-bg.svg';
import AvatarPlaceholder from '../../images/zeeve3/avatar-placeholder.svg';
import apiBackendInstance from '../../utils/axios';
import Urls from '../../utils/util';
import { globalConfig } from '../../config/config';

interface NavbarProps {
  onMenuButtonClick: () => void;
}
interface OrganizationListItem {
  id: string;
  organization_name: string;
  short_description: string;
  owner_id: string;
  updated_at: Date;
  created_at: Date;
  Organization_count: number;
  member_count: number;
  role: string;
  additionalRole: string;
}

const Navbar = (props: NavbarProps) => {
  const { onMenuButtonClick } = props;

  const profileDropdownMenu: HeaderDropdownItemProps[] = useMemo(() => [
    {
      title: 'My Account',
      icon: <IconUser fontSize={20} />,
      path: Urls.getMyAccountUrl(),
    },
    {
      title: 'Helpdesk',
      icon: <IconPhoneVolume fontSize={20} />,
      path: Urls.getContactDetails().helpdeskURL,
      inNewTab: true,
    },
  ], []);

  const [user, setUser] = useState({
    email: '',
    firstName: '',
    lastName: '',
  });

  const [showNotifications, setShowNotifications] = useState(false);
  const handleClose = () => setShowNotifications(false);
  const handleShow = () => setShowNotifications(true);

  const delete_cookie = (name: string) => {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
  };

  const logout = async () => {
    delete_cookie('recent');
    await TokenManager.getInstance().logout();
  };

  const [organizationList, setOrganizationList] = useState<Organization[]>();
  const { config } = globalConfig;
  const isOrganizationEnabled = config?.isOrganizationEnabled;

  useEffect(() => {
    apiBackendInstance.get(Urls.getUserInfo(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        const { data } = response;
        if (data?.data) {
          setUser({
            email: data.data.usercred,
            firstName: data.data.first_name,
            lastName: data.data.last_name,
          });
        }
      })
      .catch(() => {
        setUser({
          firstName: 'Not',
          lastName: 'Found',
          email: 'Not Found',
        });
      });

    if (isOrganizationEnabled) {
      apiBackendInstance.get(Urls.getOrganizationListUrl())
        .then((res) => {
          const { success, data } = res.data;
          if (success) {
            setOrganizationList(data?.currentPageItems.map((item: OrganizationListItem) => ({
              id: item.id,
              organization_name: item.organization_name,
              role: item.role,
            })));
          }
        });
    }
  }, []);

  return (
    <>
      <Header
        zeeveLogo={ZeeveLogo}
        avatarPlaceholder={AvatarPlaceholder}
        profileDropdownMenu={profileDropdownMenu}
        onMenuButtonClick={onMenuButtonClick}
        onClickLogout={logout}
        user={{
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
        }}
        organizationList={organizationList}
      >
        <button
          className="btn p-0"
          type="button"
          onClick={handleShow}
        >
          <NotificationBell theme="zeeve" />
        </button>
      </Header>
      <Offcanvas show={showNotifications} onHide={handleClose} placement="end">
        <Offcanvas.Header
          className="border-bottom"
          closeButton
          style={{
            height: '80px',
          }}
        >
          <Offcanvas.Title as="h2">Notifications</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body
          className="p-0"
          style={{
            overflowY: 'auto',
            maxHeight: 'calc(100% - 80px)',
          }}
        >
          <div className="mt-3">
            <div className="container">
              <NotificationList />
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
export default Navbar;
